module.exports = __webpack_public_path__ + "img/help-alignanalysis-video.bd9cbc10.png";